import { useAuthFetch } from '@cko/dashboard-shared';
import { useCallback } from 'react';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UserProfile } from './types';

export const useGetUserProfileFetcher = () => {
  const fetch = useAuthFetch();

  return useCallback(
    async ({ queryKey }: QueryFunctionContext) => {
      const [path] = queryKey as [string];

      const response = await fetch(path, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const userProfile: UserProfile = await response.json();
      return userProfile;
    },
    [fetch],
  );
};
